/**
 * Durable “user allowed geolocation” session signal for Obchody directory warm path (G5).
 *
 * Dual path with Permissions API:
 * - Chromium/Firefox: `navigator.permissions.query({ name: 'geolocation' })`
 *   → state === 'granted' means warm `getCurrentPosition` will not prompt.
 * - Safari / older browsers without Permissions API: no durable grant probe.
 *   After a successful fix (distanceAsc or warm), set this sessionStorage flag
 *   so later visits in the same tab can warm silently. Only attempt that warm
 *   when the flag is set — first-time nameAsc loads never surprise-prompt.
 *   If the grant was revoked, PERMISSION_DENIED fails silently; clear the flag.
 *
 * Key: `rpapp.customer.geoAllowed.v1` = '1'
 */

export const DIRECTORY_GEO_ALLOWED_SESSION_KEY = 'rpapp.customer.geoAllowed.v1';

export function readDirectoryGeoAllowedFlag(): boolean {
  if (typeof sessionStorage === 'undefined') {
    return false;
  }
  try {
    return sessionStorage.getItem(DIRECTORY_GEO_ALLOWED_SESSION_KEY) === '1';
  } catch {
    return false;
  }
}

export function writeDirectoryGeoAllowedFlag(allowed: boolean): void {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  try {
    if (allowed) {
      sessionStorage.setItem(DIRECTORY_GEO_ALLOWED_SESSION_KEY, '1');
    } else {
      sessionStorage.removeItem(DIRECTORY_GEO_ALLOWED_SESSION_KEY);
    }
  } catch {
    // private mode / quota — warm path degrades to Permissions API only
  }
}
